import axios from "axios";
// Next we make an 'instance' of it
const instance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_API /* ||
    "http://skyuback-env.eba-6db82ax6.eu-west-1.elasticbeanstalk.com", */,
});

export default instance;
